import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { Client, NoteDetail, NoteListItem } from "creso-core/types";
import type { RecordingStatus } from "./notebook-dialog";

export type NotebookFilters = { date: Date; client: Client | null };

export type View = "notes" | "calendar";

export type NotebookContextValue = {
  selectedNote: NoteListItem | null;
  setSelectedNote: Dispatch<SetStateAction<NoteListItem | null>>;
  filters: NotebookFilters;
  setFilters: Dispatch<SetStateAction<NotebookFilters>>;
  recordingStatus: RecordingStatus;
  reset: (note?: NoteListItem, clear?: boolean) => void;
  view: View;
  setView: (v: View) => void;
  saveNote: (note: NoteDetail) => Promise<void>;
  clientIds?: number[];
};

export const NotebookContext = createContext<NotebookContextValue | null>(null);

export function useNotebookContext() {
  const context = useContext(NotebookContext);
  if (!context) {
    throw new Error(
      "useNotebookContext must be used within a NotebookContext.Provider"
    );
  }
  return context;
}
